<template>
    <div class="collapse-container">
        <el-collapse :value="opens">
            <el-collapse-item v-for="(item, index) in keyArray"  :key="index" :name="index" :title="item">
                <CollapseContent :data="data[item]"></CollapseContent>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
import CollapseContent from './CollapseContent';
export default {
    props: {
        data: {
            type: Object,
            default: function () {
                return {
                    "电气": {
                        "额定电压": "380/220",
                        "额定频率(HZ)": "50",
                        "额定电流": "80"
                    },
                    "设备结构": {
                        "防护等级": "0"
                    },
                    "其他": {
                        "购买时间": "2020-06-16"
                    }
                }
            }
        }
    },
    computed: {
        keyArray: function () {
           this.$emit('Arr',this.data) 
           
            return Object.keys(this.data);
        },
        opens: function () {
            let arr = [];
            for (let i=0; i<=this.keyArray.length-1; i++) {
                arr.push(i);
                
            }
            return arr;
        }
    },
    components: {
        CollapseContent,
    },
}
</script>

<style lang="less" scoped>
.collapse-container {
    height: 100%;
}
</style>

{
    "电气": {
        "额定电压": "380/220",
        "额定频率(HZ)": "50",
        "额定电流": "80"
    },
    "设备结构": {
        "防护等级": "0"
    },
    "其他": {
        "购买时间": "2020-06-16"
    }
}

==> 提取key: ['电气', '设备结构', '其它']
==> 循环key数组渲染出每个collapse-item,
==> 使用data[key]的数据渲染出来内容 